import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import { QUASIMODO_CON_COORD } from "../types/Config";


const header = "Quasimodo Mode:";
const coords = {
  horizontal: QUASIMODO_CON_COORD,
  vertical: { x: -200, y: 630 }
}
const handleFunc = (isActive: boolean) => eventBus.emit(EnumEventBus.quasimodoMode, isActive);


export default class QuasimodoModeSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ header, coords, handleFunc });
  }

}